import { ReelEngine } from "../../core/reel/engine/ReelEngine";
import { gsap, Back, Bounce, Elastic } from 'gsap';
import { Helper } from "../../core/utils/Helper";
import { GameConfig } from "../config/base/GameConfig";
import { SanSymbolData } from "./Symbol/SanSymbolData";
import { MathHelper } from "../../core/utils/MathHelper";

export interface IExpandingConfig extends IExpandAnimateConfig {
    reelID:number[],
}

export interface IExpandAnimateConfig {
    shrink:     boolean;
    targetSym:  number;

    type:number;
    
    duration?:  number;
    ease?:      any;
}

export class SanEnginePlayer extends ReelEngine {
    public Stop(duration: number = 0, ease?: any): gsap.core.Timeline {
        this.nextTimeline = Helper.setTimeline(
            this.nextTimeline,
            {
                paused: true,
                onComplete: () => this.onSpinStopCompleted(),
            }
        );

        this.nextTimeline.to(this, {
            duration: duration,
            ease: ease,
            yPos: 0,
        });

        this.nextTimeline.add(() => Helper.triggerIfExist(this.callbacks.onStopCallback), 0);
        this.nextTimeline.add(() => this.onBounce(), duration * 0.92);

        return this.nextTimeline;
    }

    public SpinnerStart(duration: number = 0, ease?: any): gsap.core.Timeline {
        this.nextTimeline = Helper.setTimeline(
            this.nextTimeline,
            {
                paused: true,
                onStart: () => Helper.triggerIfExist(this.callbacks.onStartCallBack),
                onComplete: () => this.onStartCompleted(),
            }
        );

        this.nextTimeline.to(
            this,
            {
                duration: duration,
                ease: ease,
                yPos: this.stepDistance,
            }
        );
        return this.nextTimeline;
    }

    protected onSpinnerStopCompleted(): void {
        Helper.triggerIfExist(this.callbacks.onCompletedStopCallback);
    }

    public SpinnerStop(duration: number, ease?: any): gsap.core.Timeline {
        this.nextTimeline = Helper.setTimeline(
            this.nextTimeline,
            {
                paused: true,
                onComplete: () => this.onSpinnerStopCompleted(),
            }
        );

        // const nudgeDurr:number = 0.4;

        this.nextTimeline.to(this, {
            duration: duration,
            ease: ease,
            yPos: MathHelper.randomIntInRange(-this.stepDistance*0.25,this.stepDistance*0.25),
        });

        // this.nextTimeline.to(this, {
        //     duration: nudgeDurr,
        //     ease: "back.out(4)",
        //     yPos: 0,
        // },"-="+nudgeDurr);

        this.nextTimeline.add(() => Helper.triggerIfExist(this.callbacks.onStopCallback), 0);
        this.nextTimeline.add(() => this.onBounce(), duration * 0.9);

        return this.nextTimeline;
    }

    public ExpandSymbolSQ(conf:IExpandAnimateConfig, cont:PIXI.Container, windowAmount:number):gsap.core.Timeline{ 

        /*
        * Calculation heaven for defining Size ratio for correct positioning and scaling depending on config.
        */

        let duration:number = (conf.duration != undefined ? conf.duration : 0.5)!;
        let easeCurve:any = GameConfig.REEL_ENGINE_CONFIG.EASING.EXPAND;// (conf.ease != undefined ? conf.ease : undefined)!;

        /*
        * -------------------------------------------------------------------------------------------------------
        */

        // Time to loop threw the symbols on the reel and give them the configData depending on their current positions.
        let Tweens:gsap.core.Tween[] = [];
        this.nextTimeline = new gsap.core.Timeline({
            paused:true,
            onComplete: () => { 
                this.callbacks.onCompletedExpanding ? this.callbacks.onCompletedExpanding() : null;
             }
        });

        let newSmallSize:number = SanSymbolData.fetchSymHeightSize(2);
        let newLargeSize:number = this.stepDistance;

        let sizeTarget:number = conf.shrink ? newSmallSize : newLargeSize;

        const posOnBott:boolean = conf.targetSym > 0;
        let accPosition:number = 0;
        if(posOnBott){
            accPosition = conf.shrink ? newLargeSize + newSmallSize*1.5 : 0;
        }else{
            accPosition = conf.shrink ? -sizeTarget*0.5 : 0 ;
        }

        for(let pos = 0; pos < windowAmount; pos++){
            
            let posID:number = pos + 1;
            let sym:PIXI.Sprite = cont.children[posID] as PIXI.Sprite;

            let fromPosY:number = sym.position.y;
            if(duration == 0) sym.position.y = accPosition;
            else
                Tweens.push(gsap.fromTo(sym.position, duration, { y:fromPosY}, {
                    y : accPosition,
                    ease: easeCurve
                }));
            accPosition += sizeTarget;
        }
        
        this.nextTimeline.add(Tweens);

        return this.nextTimeline;
    }

    public StopTeaser2(durr:number):gsap.core.Timeline {
        this.nextTimeline = new gsap.core.Timeline({ 
            paused:true,
            onComplete:() =>  this.onSpinStopCompleted()
        });

        this.nextTimeline.add(() => { Helper.triggerIfExist(this.callbacks.onStopCallback)},0);
        const tt:number = -this.stepDistance*0.25;
        this.nextTimeline.to(this, {
            duration:durr,
            ease : "Back.easeOut.config(2.2)",
            yPos : tt,
        });

        this.nextTimeline.add(() => this.onBounce(), "-=" + durr*0.05);

        this.nextTimeline.to(this, {
            duration:0.25,
            ease : "Bounce.easeOut",
            yPos: 0});

        return this.nextTimeline;
    }
}